var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud-error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,31.1c-.2,4.8-3.8,9.9-11.5,9.9H34a1.7,1.7,0,0,1-1.4-.6A2,2,0,0,1,32,39a2,2,0,0,1,2-2h.5c7.1,0,7.5-5.4,7.5-6a6.2,6.2,0,0,0-4.1-6h-.2a1.7,1.7,0,0,1-1.2-1.7v-.4a6,6,0,0,0-1.8-4.4A6.4,6.4,0,0,0,29,17.1h-.5A2,2,0,0,1,26.7,16a8.8,8.8,0,0,0-2.8-3.4A7,7,0,0,0,19.5,11a7.7,7.7,0,0,0-5.9,2.6,9.1,9.1,0,0,0-2.2,6.6h0a1.8,1.8,0,0,1-1.1,1.9,8.1,8.1,0,0,0-2.7,2.5,7.3,7.3,0,0,0-1.5,3.5,7.6,7.6,0,0,0,2,6.7A7.9,7.9,0,0,0,14,37h2a2.1,2.1,0,0,1,2,2,2,2,0,0,1-2,2H14a12.4,12.4,0,0,1-8.7-3.2A11.5,11.5,0,0,1,2.2,27.6a11.8,11.8,0,0,1,5.2-8.2A12.4,12.4,0,0,1,10.6,11a11.6,11.6,0,0,1,8.9-4,12.2,12.2,0,0,1,10.1,6,9.8,9.8,0,0,1,7.5,2.3,9.1,9.1,0,0,1,3.4,6.5A9.9,9.9,0,0,1,46,31.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8,28l3.6-3.6a2,2,0,0,0-2.8-2.8L24,25.2l-3.6-3.6a2,2,0,0,0-2.8,2.8L21.2,28l-3.6,3.6a1.9,1.9,0,0,0,0,2.8,1.9,1.9,0,0,0,2.8,0L24,30.8l3.6,3.6a1.9,1.9,0,0,0,2.8,0,1.9,1.9,0,0,0,0-2.8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudError);
export default __webpack_public_path__ + "static/media/cloud-error.96535d82.svg";
export { ForwardRef as ReactComponent };